<template>
    <div class="earnest-money-check-page">
        <div class="page-header">
            <h2 class="page-title">核实保证金</h2>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addBatchCheck">
                新增
            </el-button>
        </div>

        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <el-form :model="searchForm" :inline="true" size="small">
                    <el-form-item label="项目名称">
                        <el-input v-model="searchForm.projectName" placeholder="请输入" clearable style="width: 220px" />
                    </el-form-item>
                    <el-form-item label="标段名称">
                        <el-input v-model="searchForm.sectionName" placeholder="请输入" clearable style="width: 220px" />
                    </el-form-item>
                    <el-form-item label="投标人名称">
                        <el-input v-model="searchForm.bidderName" placeholder="请输入" clearable style="width: 220px" />
                    </el-form-item>
                    <el-form-item label="核实状态">
                        <el-select v-model="searchForm.verifyStatus" placeholder="请选择核实状态" clearable
                            style="width: 160px">
                            <el-option label="未核实" :value="0" />
                            <el-option label="已核实" :value="1" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" :loading="loading" @click="handleSearch">查询</el-button>
                        <el-button @click="handleReset">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <div class="table-area">
                <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%"
                    :header-cell-style="{ background: '#fafafa', color: '#333', fontWeight: '600' }"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="50" align="center" v-if="selectType == 0" />
                    <el-table-column type="index" label="编号" width="70" align="center" />
                    <el-table-column prop="projectName" label="项目名称" />
                    <el-table-column prop="sectionName" label="标段名称" />
                    <el-table-column prop="bidderName" label="投标人名称" />
                    <el-table-column prop="depositAmount" label="保证金金额" align="right" />
                    <el-table-column prop="receiptTime" label="到账时间" />
                    <el-table-column label="操作" width="200" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleDelete(scope.row)" v-if="selectType == 0">
                                删除
                            </el-button>
                            <el-button type="text" size="small" @click="handleEdit(scope.row, 0)" v-if="selectType == 1">
                                详情
                            </el-button>
                            <el-button type="text" size="small" @click="handleEdit(scope.row, 1)" v-if="selectType == 0">
                                编辑
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 批量操作栏 -->
            <div class="batch-actions" v-if="selectedRows.length > 0">
                <span class="selected-info">已选择 {{ selectedRows.length }} 项</span>
                <el-button type="primary" size="small" @click="handleBatchVerify">批量核实</el-button>
                <el-button type="danger" size="small" @click="handleBatchDelete">批量删除</el-button>
            </div>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination background :current-page="pagination.pageNum" :page-size="pagination.pageSize"
                :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>

        <!-- 新增/编辑保证金收款记录弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="depositForm" :model="depositForm" :rules="depositRules" label-width="120px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="项目名称" prop="projectName">
                            <el-input v-model="depositForm.projectName" placeholder="请输入项目名称" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="标段名称" prop="sectionName">
                            <el-input v-model="depositForm.sectionName" placeholder="请输入标段名称" />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="投标人名称" prop="bidderName">
                            <el-input v-model="depositForm.bidderName" placeholder="请输入投标人名称" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="保证金金额" prop="depositAmount">
                            <el-input-number v-model="depositForm.depositAmount" :min="0" :precision="2"
                                placeholder="请输入保证金金额" style="width: 100%;" />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="到账时间" prop="receiptTime">
                            <el-date-picker v-model="depositForm.receiptTime" type="datetime"
                                placeholder="请选择到账时间" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注">
                            <el-input v-model="depositForm.remark" placeholder="请输入备注" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleDialogClose">{{ type == 0 ? '关闭' : '取消' }}</el-button>
                <el-button type="primary" :loading="submitting" @click="handleSubmit" v-if="type == 1">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { addDepositReceipt,batchDeleteDepositReceipt,batchVerifyDepositReceipt,deleteDepositReceipt,getDepositReceiptDetail,getDepositReceiptPage,updateDepositReceipt,verifyDepositReceipt } from '@/api/deposit-receipt/api'
export default {
    name: 'EarnestMoneyCheck',
    data() {
        return {
            selectType: 0,
            type: 0,
            loading: false,
            searchForm: {
                projectName: '',
                sectionName: '',
                bidderName: '',
                verifyStatus: 0,
            },
            tableData: [],
            selectedRows: [],
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            // 弹窗相关
            dialogVisible: false,
            dialogTitle: '新增保证金收款记录',
            submitting: false,
            depositForm: {
                projectName: '',
                sectionName: '',
                bidderName: '',
                depositAmount: null,
                receiptTime: '',
                remark: ''
            },
            depositRules: {
                projectName: [
                    { required: true, message: '请输入项目名称' }
                ],
                sectionName: [
                    { required: true, message: '请输入标段名称' }
                ],
                bidderName: [
                    { required: true, message: '请输入投标人名称' }
                ],
                depositAmount: [
                    { required: true, message: '请输入保证金金额' }
                ],
                receiptTime: [
                    { required: true, message: '请选择到账时间' }
                ]
            }
        }
    },
    mounted() {
        this.getDepositReceiptPage()
    },
    methods: {
        // 获取列表
        getDepositReceiptPage() {
            this.tableData = []
            getDepositReceiptPage({
                pageNum: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                bidderName: this.searchForm.bidderName,
                projectName: this.searchForm.projectName,
                sectionName: this.searchForm.sectionName,
                verifyStatus: this.searchForm.verifyStatus
            }).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data.records
                    this.pagination.total = res.data.total
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        // 新增保证金收款记录
        addBatchCheck() {
            this.type = 1
            this.dialogTitle = '新增保证金收款记录'
            this.resetForm()
            this.dialogVisible = true
        },

        // 关闭弹窗
        handleDialogClose() {
            this.dialogVisible = false
            this.resetForm()
        },

        // 重置表单
        resetForm() {
            this.depositForm = {
                projectName: '',
                sectionName: '',
                bidderName: '',
                depositAmount: null,
                receiptTime: '',
                remark: ''
            }
            this.$nextTick(() => {
                if (this.$refs.depositForm) {
                    this.$refs.depositForm.clearValidate()
                }
            })
        },

        // 提交表单
        handleSubmit() {
            this.$refs.depositForm.validate(async (valid) => {
                if (!valid) {
                    return false
                }

                this.submitting = true
                try {
                    let res
                    if (this.depositForm.id) {
                        // 编辑
                        res = await updateDepositReceipt(this.depositForm)
                        if (res.code === 200) {
                            this.$message.success('修改成功')
                            this.dialogVisible = false
                            this.getDepositReceiptPage()
                        } else {
                            this.$message.error(res.msg || '修改失败')
                        }
                    } else {
                        // 新增
                        res = await addDepositReceipt(this.depositForm)
                        if (res.code === 200) {
                            this.$message.success('新增成功')
                            this.dialogVisible = false
                            this.getDepositReceiptPage()
                        } else {
                            this.$message.error(res.msg || '新增失败')
                        }
                    }
                } catch (error) {
                    this.$message.error('操作失败，请稍后重试')
                } finally {
                    this.submitting = false
                }
            })
        },

        handleSearch() {
            this.selectType = this.searchForm.verifyStatus
            this.pagination.pageNum = 1
            this.getDepositReceiptPage()
        },

        handleReset() {
            this.searchForm.projectName = ''
            this.searchForm.sectionName = ''
            this.searchForm.bidderName = ''
            this.pagination.pageNum = 1
            this.getDepositReceiptPage()
        },

        handleSelectionChange(rows) {
            this.selectedRows = rows || []
        },

        // 编辑操作
        handleEdit(row, type) {
            this.resetForm()
            this.type = type
            this.dialogTitle = type == 0 ? "查看保证金收款记录" : "编辑保证金收款记录"
            getDepositReceiptDetail(row.id).then(res => {
                if (res.code === 200) {
                    this.depositForm = {
                        id: res.data.id,
                        projectName: res.data.projectName,
                        sectionName: res.data.sectionName,
                        bidderName: res.data.bidderName,
                        depositAmount: res.data.depositAmount,
                        receiptTime: res.data.receiptTime,
                        remark: res.data.remark
                    }
                    this.dialogVisible = true
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        // 批量核实
        handleBatchVerify() {
            const count = this.selectedRows.length
            if (count === 0) {
                this.$message.warning('请先勾选要核实的记录')
                return
            }
            this.$confirm(`确认对已勾选的 ${count} 条记录进行核实吗？`, '提示', {
                type: 'warning',
                confirmButtonText: '确定核实',
                cancelButtonText: '取消'
            }).then(async () => {
                const ids = this.selectedRows.map(row => row.id)
                try {
                    const res = await batchVerifyDepositReceipt({
                        ids: ids,
                        verifyStatus: 1
                    })
                    if (res.code === 200) {
                        this.$message.success('核实成功')
                        this.selectedRows = []
                        this.getDepositReceiptPage()
                    } else {
                        this.$message.error(res.msg || '核实失败')
                    }
                } catch (error) {
                    this.$message.error('操作失败，请稍后重试')
                }
            }).catch(() => { })
        },

        // 批量删除
        handleBatchDelete() {
            const count = this.selectedRows.length
            if (count === 0) {
                this.$message.warning('请先勾选要删除的记录')
                return
            }
            this.$confirm(`确认删除已勾选的 ${count} 条记录吗？删除后将无法恢复。`, '警告', {
                type: 'warning',
                confirmButtonText: '确定删除',
                cancelButtonText: '取消'
            }).then(async () => {
                const ids = this.selectedRows.map(row => row.id)
                try {
                    const res = await batchDeleteDepositReceipt(ids)
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.selectedRows = []
                        this.getDepositReceiptPage()
                    } else {
                        this.$message.error(res.msg || '删除失败')
                    }
                } catch (error) {
                    this.$message.error('操作失败，请稍后重试')
                }
            }).catch(() => { })
        },

        // 单个删除
        handleDelete(row) {
            this.$confirm(` 是否删除项目名称为${row.projectName}的记录？删除后将无法恢复。`, '警告', {
                type: 'warning',
                confirmButtonText: '确定删除',
                cancelButtonText: '取消'
            }).then(async () => {
                try {
                    const res = await deleteDepositReceipt(row.id)
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.getDepositReceiptPage()
                    } else {
                        this.$message.error(res.msg || '删除失败')
                    }
                } catch (error) {
                    this.$message.error('操作失败，请稍后重试')
                }
            }).catch(() => { })
        },

        handleSizeChange(size) {
            this.pagination.pageSize = size
            this.pagination.pageNum = 1
            this.getDepositReceiptPage()
        },

        handleCurrentChange(page) {
            this.pagination.pageNum = page
            this.getDepositReceiptPage()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common-page-styles.less';

.common-list-page-styles(earnest-money-check-page);

.table-section {
    .table-area {
        margin-bottom: 0;
    }

    .batch-actions {
        padding: 16px 20px;
        background-color: #f5f7fa;
        border-top: 1px solid #e4e7ed;
        border-radius: 0 0 8px 8px;
        display: flex;
        align-items: center;
        gap: 12px;

        .selected-info {
            font-size: 14px;
            color: #606266;
            font-weight: 500;
            margin-right: auto;
        }
    }
}
</style>
